import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { localStorageGetItem } from '../utils/eventUtils'
import { useSettingsContext } from '../utils/eventUtils'

// ----------------------------------------------------------------------
// export function useLocales() {
//     const langStorage = localStorageGetItem('i18nextLng')

//     const currentLang = allLangs.find((lang) => lang.value === langStorage) || defaultLang

//     return {
//         allLangs,
//         currentLang,
//     }
// }

// ----------------------------------------------------------------------

export function useTranslate() {
    const { t, i18n, ready } = useTranslation()

    const settings = useSettingsContext()

    const onChangeLang = useCallback(
        (newLang) => {
            if (i18n && typeof i18n.changeLanguage === 'function') {
                i18n.changeLanguage(newLang, (err) => {
                    if (err) {
                        console.error('언어 변경 중 오류 발생:', err)
                    } else {
                        localStorage.setItem('i18nextLng', newLang)
                        console.log('언어 변경 성공:', newLang)
                    }
                })
            }
        },
        [i18n],
    )

    return {
        t,
        i18n,
        ready,
        onChangeLang,
    }
}
